module.exports = __webpack_public_path__ + "static/media/ow.b1d5473b.webp";